/**
 * КОНТУРНОЕ СВЕЧЕНИЕ АКТИВНОГО ИГРОКА: одно на флаги его центральных кварталов и на
 * его отряды, чтобы на поле сразу читалось, чей ход. Яркий контур, белый сверху и
 * золотой снизу, а за ним раскаленное свечение, которое дышит: у контура оно светлое,
 * наружу уходит в насыщенный оранжевый. Просто золото теряется на песочных подложках
 * и рудниках. Пульс общий, поэтому все подсвеченное у игрока дышит в такт. У остальных
 * игроков контур черный, как раньше.
 */
export const ACTIVE_GLOW = {
  contourTop: 0xffffff,
  contourBottom: 0xffe048,
  glowInner: 0xffe060,
  glowOuter: 0xff3c00,
  pulseMs: 1300,
  minAlpha: 0.65,
  maxAlpha: 1,
  minScale: 0.985,
  maxScale: 1.03,
};

/**
 * Свечение отряда считается из уменьшенного силуэта при первом показе этого типа:
 * размытому пятну высокое разрешение не нужно, поэтому это быстро и картинка мала
 */
export const UNIT_GLOW_TEXTURE = {
  // Во сколько раз меньше исходной иконки
  sourceScale: 0.25,
  // Запас вокруг силуэта и радиус размытия: в точках уменьшенной картинки
  pad: 34,
  blurRadius: 9,
  blurPasses: 2,
  // Усиление и степень спада: чтобы у самого контура свечение было плотным
  gain: 5,
  falloff: 0.8,
};
